import { useCallback, useState } from 'react';

import { Footer } from '../Footer';
import { Header } from '../Header';
import { DiscoverySection } from './DiscoverySection';
import { Hero } from './Hero';

type LegacyHomepageProps = {
  showStocksAvailabilityBanner: boolean;
};

/** Pre-revamp homepage: animated hero, search bar and the discovery table. */
export function LegacyHomepage({ showStocksAvailabilityBanner }: LegacyHomepageProps) {
  const [hideSearch, setHideSearch] = useState(true);

  // Reveal the header search once the hero search bar scrolls out of view.
  const sentinelRef = useCallback((node: HTMLDivElement | null) => {
    if (!node) return;

    const observer = new IntersectionObserver(
      (entries) => {
        setHideSearch(entries[0].isIntersecting);
      },
      { rootMargin: '-250px 0px 0px 0px' },
    );
    observer.observe(node);

    return () => observer.disconnect();
  }, []);

  return (
    <div className="overflow-hidden h-fit">
      <Header isHomepage={true} hideSearch={hideSearch} />
      <Hero />
      <div ref={sentinelRef} className="h-px" aria-hidden={true} />
      <DiscoverySection
        showStocksAvailabilityBanner={showStocksAvailabilityBanner}
        includePopular
      />
      <div className="h-14" />
      <hr className="border-token-gray-300" />
      <Footer isHomepage={true} />
    </div>
  );
}
